import { render, staticRenderFns } from "./UserSales.vue?vue&type=template&id=44097b52&"
import script from "./UserSales.vue?vue&type=script&lang=js&"
export * from "./UserSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports